<template>
    <div>
    <div class="total">
        <div class="total--delivery">
            <p class="total--delivery--text">{{boxText}}</p>
            <div class="total--delivery--amount">
                <p class="total--delivery--value" :class="{'strike-out': showDiscountAmount}">{{`£${getPrice}`}}</p>
                <p class="total--delivery--value" v-if="showDiscountAmount">{{`£${boxDiscountAmount}`}}</p>
            </div>
        </div>
        <div class="total--delivery">
            <p class="total--delivery--text">{{$t('TOTAL_PRICE_DELIVERY')}}</p>
            <div class="total--delivery--amount">
                <p class="total--delivery--value" :class="{'strike-out': strikeDeliveryPrice}">{{shippingPriceText}}</p>
                <p class="total--delivery--value" v-if="strikeDeliveryPrice">{{netShippmentAmount}}</p>
            </div>
        </div>
        <div class="total--price">
            <p class="total--price--text">{{totalText}}</p>
            <div class="total--price--container">
                <p class="total--price--value" :class="{'strike-out': strikeTotalPrice}">{{currency}}{{totalPriceWithDelivery}}</p>
                <p class="total--price--value" v-if="strikeTotalPrice">{{currency}}{{netTotalPrice}}</p>
            </div>
        </div>

    </div>
        <!-- <hr class="total--divider"> -->
        <coupon-section />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { PRODUCT_FAMILY_BUMPER, PRODUCT_FAMILY_STANDARD } from '@/constants/Gifting';
import CouponSection from '@/components/forms/fields/CouponSection';
import { getBoxPrice } from '@/helpers/QueryHelpers';

export default {
    name: 'TotalSection',
    components: {
        CouponSection,
    },
    computed: {
        ...mapGetters({
            selectedProduct: 'register/getSelectedProductDetails',
            couponProperties: 'register/getCouponProperties',
            boxPrice: 'register/getBoxPrice',
            currency: 'localisation/getCurrency',
            deliveryPrice: 'register/getDeliveryPrice',
            SelectedBoxName: 'register/getSelectedProductName',
            selectedPlan: 'register/getSelectedPlan',
        }),
        showDiscountAmount() {
            return this.couponProperties && Number(this.couponProperties.payable_amount) < Number(this.getPrice);
        },
        boxDiscountAmount() {
            return this.SelectedBoxName === PRODUCT_FAMILY_BUMPER ? this.couponProperties.payable_amount_bumper : this.couponPayableAmount;
        },
        couponPayableAmount() {
            const globalParams = this.$globalQueryParams;
            if (globalParams.np === '1' || globalParams.np === '2') return this.couponProperties?.payable_new_amount;
            return this.couponProperties?.payable_amount;
        },
        selectedBoxPrice() {
            return Number(this.selectedProduct?.price || this.boxPrice);
        },
        discountPrice() {
            let amount = this.couponProperties?.payable_amount;
            if (this.selectedProduct?.product_family.toLowerCase() === PRODUCT_FAMILY_BUMPER) amount = this.couponProperties?.payable_amount_bumper;
            return this.showDiscount ? `${this.currency}${Number(amount)}` : '';
        },
        showDiscount() {
            if (this.selectedProduct?.product_family.toLowerCase() === PRODUCT_FAMILY_BUMPER) return Number(this.couponProperties?.payable_amount_bumper) < this.selectedBoxPrice;
            if (this.selectedProduct?.product_family.toLowerCase() === PRODUCT_FAMILY_STANDARD) return Number(this.couponProperties?.payable_amount) < this.selectedBoxPrice;
            return false;
        },
        firstDeliveryFree() {
            return this.$globalQueryParams?.fdf !== '0';
        },
        strikeDeliveryPrice() {
            return this.firstDeliveryFree || (this.couponProperties && ![0, 4].includes(Number(this.couponProperties?.payable_amount_delivery)));
        },
        shippingPrice() {
            if (this.couponProperties) return this.couponProperties?.payable_amount_delivery || 0;
            return !this.firstDeliveryFree ? this.deliveryPrice : 0;
        },
        shippingPriceText() {
            return this.shippingPrice === 0 && !this.firstDeliveryFree ? this.$t('REG_SUMMARY_FREE') : `£${this.deliveryPrice}`;
        },
        netShippmentAmount() {
            if (this.firstDeliveryFree) return this.$t('REG_SUMMARY_FREE');
            if (this.couponProperties) return this.couponProperties?.payable_amount_delivery || this.$t('REG_SUMMARY_FREE');
            return this.deliveryPrice || 0;
        },
        getPrice() {
            if (!this.selectedProductID) return getBoxPrice(this.boxPrice, this.deliveryPrice);
            let price = this.products?.find(product => product.id === this.selectedProductID)?.price;
            return this.SelectedBoxName === PRODUCT_FAMILY_BUMPER ? parseInt(price) : getBoxPrice(this.boxPrice, this.deliveryPrice);
        },
        totalPriceWithDelivery() {
            return this.getPrice + this.deliveryPrice;
        },
        totalPrice() {
            return this.getPrice + this.shippingPrice;
        },
        netTotalPrice() {
            if (this.couponProperties) {
                let couponPayableAmount = this.SelectedBoxName === PRODUCT_FAMILY_BUMPER ? Number(this.couponProperties?.payable_amount_bumper || 0) : Number(this.couponProperties?.payable_amount || 0);
                let couponDeliveryAmount = !this.firstDeliveryFree ? Number(this.couponProperties?.payable_amount_delivery || 0) : 0;
                let couponTotalPrice = couponPayableAmount + couponDeliveryAmount;
                this.$store.commit('register/setCheckoutPrice', couponTotalPrice.toFixed(2));
                return couponTotalPrice;
            }
            this.$store.commit('register/setCheckoutPrice', this.totalPrice.toFixed(2));
            return this.totalPrice;
        },
        strikeTotalPrice() {
            return this.firstDeliveryFree || (this.couponProperties && Number(this.couponProperties?.payable_amount) !== Number(this.getPrice));
        },
        hasDiscountOnBoxPrice() {
            return this.couponProperties && Number(this.couponProperties?.payable_amount) !== Number(this.getPrice);
        },
        boxText() {
            let plan = this.selectedPlan?.plan_interval.charAt(0).toUpperCase() + this.selectedPlan?.plan_interval.slice(1);
            return this.hasDiscountOnBoxPrice ? this.$t('REG_SUMMARY_FIRST_WEEKLY_WITH_DISCOUNT', { plan: plan }) : this.$t('REG_SUMMARY_FIRST_WEEKLY', { plan: plan });
        },
        totalText() {
            return this.firstDeliveryFree && (this.couponProperties && Number(this.couponProperties?.payable_amount) !== Number(this.getPrice)) ? this.$t('TOTAL_PRICE_TOTAL_FIRST_BOX') : this.$t('TOTAL_PRICE_TOTAL');
        },
    },
};
</script>

<style lang="scss" scoped>
.total {
    padding: 10px 20px 10px 32px;
    box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.15);
    &--price {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 0px;
        padding-bottom: 0;
        &--text {
            font-weight: 400;
            margin: 0;
            font-size: 16px;
            line-height: 24px;
        }
        &--value {
            font-weight: 400;
            margin: 0 5px;
            font-size: 18px;
            line-height: 24px;
        }
        &--container {
            display: flex;
        }
    }
    &--delivery {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0;
        &--text {
            font-size: 14px;
            line-height: 24px;
            margin: 0;
        }
        &--value {
            font-size: 14px;
            line-height: 24px;
            margin: 0 10px;
        }
        &--amount {
            display: flex;
            flex-direction: row;
            justify-content: space-around;
        }
    }
    &--divider {
        border-top: 1px solid #DFDFDF;
        margin: 5px auto;
    }
}
.strike-out {
    text-decoration: line-through;
    opacity: 0.6;
}
</style>
